const getReactAppUrl = (): string =>
    window.env.REACT_APP_ONLINE_API_BASE_URL?.replace("https://", "") as string;
export default getReactAppUrl;
